<template>
  <footer class="sc-footer">
    <div class="sc-footer__inner sc-container">
      <div class="sc-footer__left">
        <p class="sc-footer__row">
          <span class="sc-footer__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M6.5 3.5l3 1.2-1.4 3.4a13 13 0 006.8 6.8l3.4-1.4 1.2 3A15.5 15.5 0 017.2 21 15.5 15.5 0 013 16.8C3 9.4 9 3.5 16.4 3.5c.1 0 .2 0 .1 0z" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <span>
            <em>服务电话：</em>
            <a href="tel:051687766969">0516-87766969</a>
            <span class="sc-footer__sep">/</span>
            <a href="tel:17705201244">17705201244</a>
          </span>
        </p>
        <p class="sc-footer__row">
          <span class="sc-footer__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M12 22s7-5.2 7-12a7 7 0 1 0-14 0c0 6.8 7 12 7 12z" />
              <circle cx="12" cy="10" r="2.5" />
            </svg>
          </span>
          <span>
            <em>公司地址：</em>江苏省徐州市鼓楼区广山路50号
            <span class="sc-footer__sep">|</span>
            <em>邮编：</em>221005
          </span>
        </p>
        <p class="sc-footer__row">
          <span class="sc-footer__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z" />
              <path d="M9.5 12l1.8 1.8L15 10" />
            </svg>
          </span>
          <span>
            <em>版权所有：</em>苏成（江苏）能源科技有限公司
          </span>
        </p>
      </div>

      <div class="sc-footer__right">
        <p class="sc-footer__row sc-footer__row--right">
          <a
            class="sc-footer__icp"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="sc-footer__icp-mark" aria-hidden="true">◆</span>
            ICP主体备案号：苏ICP备2023015593号
          </a>
        </p>
      </div>
    </div>

    <button
      v-show="showTop"
      type="button"
      class="sc-footer__top"
      aria-label="回到顶部"
      @click="scrollTop"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
        <path d="M6 14l6-6 6 6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      showTop: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.showTop = window.scrollY > 320
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.sc-footer {
  position: relative;
  background: #2f3338;
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  line-height: 1.7;

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 32px;
    padding: 28px 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
  }

  &__left,
  &__right {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__right {
    align-items: flex-end;
    text-align: right;
  }

  &__row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 0;

    em {
      font-style: normal;
      color: rgba(255, 255, 255, 0.55);
    }

    a {
      color: rgba(255, 255, 255, 0.85);
      transition: color 0.15s ease;

      &:hover {
        color: $color-secondary;
      }
    }

    &--right {
      justify-content: flex-end;
    }
  }

  &__sep {
    margin: 0 6px;
    color: rgba(255, 255, 255, 0.35);
  }

  &__icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-top: 2px;
    color: rgba(255, 255, 255, 0.55);

    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &__icp {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: rgba(255, 255, 255, 0.72);
    transition: color 0.15s ease;

    &:hover {
      color: $color-secondary;
    }
  }

  &__icp-mark {
    color: #5b9bd5;
    font-size: 12px;
    line-height: 1;
  }

  &__top {
    position: fixed;
    right: 24px;
    bottom: 32px;
    z-index: 900;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: $color-secondary;
    color: $color-white;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(39, 174, 96, 0.35);
    transition: background 0.15s ease, transform 0.15s ease;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover {
      background: $color-secondary-dark;
      transform: translateY(-2px);
    }
  }
}

@media (max-width: $breakpoint-md) {
  .sc-footer {
    &__inner {
      flex-direction: column;
      gap: 16px;
      padding: 24px 16px 28px;
    }

    &__right {
      align-items: flex-start;
      text-align: left;
    }

    &__row--right {
      justify-content: flex-start;
    }

    &__top {
      right: 16px;
      bottom: 24px;
    }
  }
}
</style>
